import { createContext, useContext } from 'react';

// ── Destrier palette ──
const destrierDark = {
  bg: '#222226',
  cream: '#282830',
  pageBg: '#1e1e24',       // dashboard page background
  sidebarBg: '#1a1a20',    // dashboard sidebar background
  accent: '#8F7BE0',
  blue: '#00A5C4',
  ctaBlue: '#00A5C4',
  textDark: '#ECE2DB',
  textMuted: '#8b95a8',
  boardLight: '#3d3b4a',
  boardDark: '#2d2a3d',
  proBg: '#282830',
  footerBg: '#17171c',
  gridLight: '#8F7BE0',
  gridDark: '#00A5C4',
  cardBg: '#252530',
  cardBorder: '#8b95a815',
  highlight: 'rgba(143, 123, 224, 0.35)',
  lastMove: 'rgba(68, 196, 219, 0.25)',
  mode: 'dark',
};

// ── Shared card style for all dashboard pages ──
export function getCardSx(c) {
  return {
    background: `linear-gradient(135deg, ${c.bg} 0%, ${c.cream} 100%)`,
    borderRadius: '20px',
    border: `1px solid ${c.textMuted}15`,
  };
}

const ThemeContext = createContext({
  c: destrierDark,
  isDark: true,
});

export function DestrierThemeProvider({ children }) {
  const c = destrierDark;

  return (
    <ThemeContext.Provider value={{ c, isDark: true }}>
      {children}
    </ThemeContext.Provider>
  );
}

export function useDestrierTheme() {
  return useContext(ThemeContext);
}

